module.exports = __webpack_public_path__ + "img/gs.538eac89.jpg";